import React, { useEffect, useRef, useState } from "react";
import PlaybackSpeedSelect from "./PlaybackSpeedSelect";

const DEFAULT_SPEED = 1.0;

export default function ChatAudioPlayer({
  src,
  initialSpeed = DEFAULT_SPEED,
  controlsList = "nodownload noplaybackrate",
}) {
  const audioRef = useRef(null);
  const [playbackRate, setPlaybackRate] = useState(initialSpeed);

  useEffect(() => {
    if (!audioRef.current) return;
    audioRef.current.playbackRate = playbackRate;
  }, [playbackRate, src]);

  if (!src) return null;

  return (
    <div className="d-flex flex-column justify-content-start gap-2">
      <audio ref={audioRef} controls controlsList={controlsList} src={src} />
      <PlaybackSpeedSelect
        value={playbackRate}
        onChange={setPlaybackRate}
        showLabel={false}
      />
    </div>
  );
}
